import { Say } from "../widgets/Say";
import { Issue } from "./Issue";
import { PlayUrl } from "./PlayUrl";

export function Clusters() {
  return (<>
    <h2>Consonant clusters</h2>

    <p>
      Currently it does -50ms when vowel is followed by 3 or more consonants.
      For example, <Say say='comm'>comm [ˈkʰɑ200m]</Say> versus <Say say='complex.n'>complex.n [ˈkʰɑ150mpɫɛ195ks]</Say> rather
      than the longer <Issue>[ˈkʰɑ200mpɫɛ195ks]</Issue>.
      (though in this case it rounds off to 190ms versus 160ms, so it's not a full 50ms,
      could shorten further <Say>[ˈkʰɑ130m.pɫɛ195ks]</Say>).
      More noticeable in <Say>complicated</Say>: <Say>[ˈkʰɑ150mplɐ130ˌkʰɛɪ̯220ᴅɨ100d]</Say> versus <Issue>[ˈkʰɑ200mplɐ130ˌkʰɛɪ̯220ᴅɨ100d]</Issue> or
      the shorter <Say>[ˈkʰɑ130mp0lɐ130ˌkʰɛɪ̯220ᴅɨ100d]</Say>, where the first syllable and consonant cluster still sound kinda clunky,
      even with a shortened /p/.
    </p>
    <p>
      Could shorten the vowels and/or consonants when there's a cluster of consonants/
    </p>

    <ul>
      <li><Issue>pointillism</Issue>, <Issue>[ˈpʰɔɪ̯285ntʰɐ140ˌlɪ160zm̩]</Issue>,
        shorten before /ntʰ/ <Say>[ˈpʰɔɪ̯140ntʰɐ140ˌlɪ160zm̩]</Say>,
        <br />perhaps also /ntʰ/ &gt; /n/ <Say>[ˈpʰɔɪ̯140nɐ140ˌlɪ160zm̩]</Say></li>
      <li><Issue>disintegrating</Issue>, /nt/ &gt; /n/, drop secondary stress <Say>/dɪˈsɪnɨɡɹɛɪ̯ᴅɪŋ/</Say></li>
      <li>
        /t/ was dropped: <Say>hinted, integral, intellect</Say>,
        /tʰ/ is present: <Say>daintily, intimacy, intonation, identified</Say>
      </li>
      <li><Issue>unthinkable</Issue> versus <Say>/ɐn.ˈθɪŋ.kɐ.bɫ̩/</Say>,
        &nbsp;<Issue>bankable</Issue> versus <Say>/ˈbɛə̯ŋ.kə.bɫ̩/</Say>,
        &nbsp;<Issue>authentication</Issue> versus <Say>/ɑ.ˌθɛn.ɐ.ˈkʰeɪ̯.ʃn̩/</Say>,
      </li>
    </ul>

    <p>
      From <a href="https://en.wikipedia.org/wiki/Nuxalk_language">Nuxalk</a>
      <br />
      <Say>[xɬpʼχʷɬtʰɬpʰɬːskʷʰt͡s]</Say>
      <br />
      <PlayUrl url="https://upload.wikimedia.org/wikipedia/commons/transcoded/e/e1/X%C5%82p%CC%93x%CC%A3%CA%B7%C5%82t%C5%82p%C5%82%C5%82sk%CA%B7c%CC%93.ogg/X%C5%82p%CC%93x%CC%A3%CA%B7%C5%82t%C5%82p%C5%82%C5%82sk%CA%B7c%CC%93.ogg.mp3" />
    </p>
  </>);
}
